import React from 'react'
import { useSelector } from 'react-redux'
import LocationsList from '../contentPages/LocationsList'

const LocationsLibrary = () => {
	const userLogin = useSelector(state => state.userLogin)
	const { userInfo: user } = userLogin
	const userId = user._id

	return <LocationsList userId={userId} />
}

export default LocationsLibrary
